// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12p26","rootNoMargin":"styles_rootNoMargin__2dkRw"};